import { AppBar, Box, Button, Container, Stack, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { PATH_AUTH, PATH_PAGE } from 'routes/paths';
import { MHidden } from 'components/@material-extend';
import Label from 'components/Label';
import Logo from 'components/Logo';
import TryLiveDemoButton from 'components/TryLiveDemoButton';
import useOffSetTop from 'hooks/useOffSetTop';
import navConfig from './MenuConfig';
import MenuDesktop from './MenuDesktop';
import MenuMobile from './MenuMobile';

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 88;

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  height: APP_BAR_MOBILE,
  transition: theme.transitions.create(['height', 'background-color'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('md')]: {
    height: APP_BAR_DESKTOP,
  },
}));

const ToolbarShadowStyle = styled('div')(({ theme }) => ({
  left: 0,
  right: 0,
  bottom: 0,
  height: 24,
  zIndex: -1,
  margin: 'auto',
  borderRadius: '50%',
  position: 'absolute',
  width: `calc(100% - 48px)`,
  boxShadow: theme.customShadows.z8,
}));

// ----------------------------------------------------------------------

export default function MainNavbar() {
  const isOffset = useOffSetTop(100);
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  return (
    <AppBar sx={{ boxShadow: 0, bgcolor: 'transparent' }}>
      <ToolbarStyle
        disableGutters
        sx={{
          ...(isOffset && {
            bgcolor: 'background.default',
            height: { md: APP_BAR_DESKTOP - 16 },
          }),
        }}
      >
        <Container
          maxWidth='lg'
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <RouterLink to='/'>
            <Logo />
          </RouterLink>
          <Label color='info' sx={{ ml: 1 }}>
            beta
          </Label>
          <Box sx={{ flexGrow: 1 }} />

          <MHidden width='mdDown'>
            <MenuDesktop isOffset={isOffset} isHome={isHome} navConfig={navConfig} />
          </MHidden>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            <Stack direction='row' spacing={1} alignItems='center' flexWrap='wrap' justifyContent='flex-end' useFlexGap>
              <Button
                variant='text'
                component={RouterLink}
                to={PATH_PAGE.requestDemo}
                sx={{ display: { xs: 'none', md: 'inline-flex' }, whiteSpace: 'nowrap' }}
              >
                Request demo
              </Button>
              <TryLiveDemoButton size='small' sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />
              <Button variant='contained' component={RouterLink} to={PATH_AUTH.login} size='small' sx={{ whiteSpace: 'nowrap' }}>
                Login
              </Button>
            </Stack>

            <MHidden width='mdUp'>
              <MenuMobile isOffset={isOffset} isHome={isHome} navConfig={navConfig} />
            </MHidden>
          </Box>
        </Container>
      </ToolbarStyle>

      {isOffset && <ToolbarShadowStyle />}
    </AppBar>
  );
}
